<div class="app-body login">
  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-8 mx-auto">
          <div class="card-group">
            <div class="card">
              <div class="card-body">
                <div class="logo"><img src="assets/img/brand/trofaco-logo@2x.png" /></div>
                <form (ngSubmit)="onLogin()">
                  <p>Sign In to your account</p>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-user"></i></span>
                    </div>
                    <input type="text" [ngClass]="{'is-invalid': !model.isUsernameValid }" [(ngModel)]="model.username"
                      name="username" type="email" class=" form-control"
                      placeholder="Username" autocomplete="username" required>
                    <div class="invalid-feedback" [hidden]="model.isUsernameValid">Username is required</div>
                  </div>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input type="password" [ngClass]="{'is-invalid': !model.isPasswordValid  || !model.isFail }"
                      name="password" [(ngModel)]="model.password" class="form-control"
                      placeholder="Password" autocomplete="current-password" required>
                    <div class="invalid-feedback" [hidden]="model.isPasswordValid">Password is required</div>
                    <div class="invalid-feedback" [hidden]="model.isFail">Invalid username or password</div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <button type="submit" class="btn btn-primary btn-block">Login</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>